// extracted by mini-css-extract-plugin
export default {"container":"InputControl_container__C21eH","inputContainer":"InputControl_inputContainer__d6AzC","icon":"InputControl_icon__aSN-Q"};